// Complyon routes
import Configslayout from "@/layout/config_base_layout/ConfigsLayout.vue";
import CommandCenter from "@/views/complyon_views/CommandCenter/CommandCenter.vue";
import ControlsLibrary from "@/views/complyon_views/ControlsLibrary/ComplyonControlsLibrary.vue";
import DelegationOfAuthority from "@/views/complyon_views/DelegationOfAuthority/ComplyonDelegationAuthority.vue";
import MyTasks from "@/views/complyon_views/MyTasks/MyTasks.vue";
import Governance from "@/views/complyon_views/Governance/ComplyonGovernance.vue";
import CompliancePolicies from "@/views/complyon_views/Policies/ComplyonPolicies.vue";
import ComplianceProcurement from "@/views/complyon_views/Procurement/ComplyonProcurement.vue";
import ObligationsRegister from "@/views/complyon_views/ObligationsRegister/ComplyonObligationsRegister.vue";
import ExceptionsDeviations from "@/views/complyon_views/ExceptionsDeviations/ComplyonExceptionsDeviations.vue";
import FindingsCorrectiveActions from "@/views/complyon_views/CorrectiveActions/ComplyonFindingsCorrectiveActions.vue";
import FinanceCompliance from "@/views/complyon_views/Finance/ComplyonFinance.vue";
import ContractLifecycle from "@/views/complyon_views/Contracts/ComplyonContracts.vue";
import EmployeeRegister from "@/views/complyon_views/Employees/ComplyonEmployees.vue";
import DataPrivacy from "@/views/complyon_views/DataPrivacy/ComplyonDataPrivacy.vue";
import RecordsRetention from "@/views/complyon_views/RecordsRetention/ComplyonRecordsRetention.vue";
import BusinessContinuity from "@/views/complyon_views/BusinessContinuity/ComplyonBusinessContinuity.vue";
import SupplierRegister from "@/views/complyon_views/Suppliers/ComplyonSupplierRegister.vue";
import AssetRegister from "@/views/complyon_views/Assets/ComplyonAssets.vue";
import FacilitiesSites from "@/views/complyon_views/FacilitiesSites/ComplyonFacilitiesSites.vue";
import HealthSafetyEnvironment from "@/views/complyon_views/HealthSafetyEnvironment/ComplyonHealthSafetyEnvironment.vue";
import LicencesPermitsCertifications from "@/views/complyon_views/LicencesPermitsCertifications/ComplyonLicencesPermitsCertifications.vue";
import InsuranceClaims from "@/views/complyon_views/InsuranceClaims/ComplyonInsuranceClaims.vue";
import ServiceDeliveryPerformance from "@/views/complyon_views/ServiceDeliveryPerformance/ComplyonServiceDeliveryPerformance.vue";
import GrantFundingCompliance from "@/views/complyon_views/GrantFundingCompliance/ComplyonGrantFundingCompliance.vue";
import TrainingProgram from "@/views/complyon_views/Training/ComplyonTraining.vue";
import ItSecurity from "@/views/complyon_views/ITSecurity/ComplyonItSecurity.vue";
import RisksDashboard from "@/views/complyon_views/Risks/ComplyonRisks.vue";
import IncidentsCases from "@/views/complyon_views/IncidentsCases/ComplyonIncidentsCases.vue";
import ConflictsOfInterest from "@/views/complyon_views/ConflictsOfInterest/ComplyonConflictsOfInterest.vue";
import LegalMattersLitigation from "@/views/complyon_views/LegalMatters/ComplyonLegalMatters.vue";
import ComplaintsGrievances from "@/views/complyon_views/ComplaintsGrievances/ComplyonComplaintsGrievances.vue";
import EthicsWhistleblowing from "@/views/complyon_views/EthicsWhistleblowing/ComplyonEthicsWhistleblowing.vue";
import AuditsRegister from "@/views/complyon_views/Audits/ComplyonAudits.vue";
import RegulatoryCalendar from "@/views/complyon_views/RegulatoryCalendar/ComplyonRegulatoryCalendar.vue";
import EvidenceVault from "@/views/complyon_views/EvidenceVault/ComplyonEvidenceVault.vue";
import ReportsDashboard from "@/views/complyon_views/Reports/ComplyonReports.vue";
import BoardAuditPacks from "@/views/complyon_views/BoardAuditPacks/ComplyonBoardAuditPacks.vue";
import OrganisationStructure from "@/views/complyon_views/OrganisationStructure/ComplyonOrganisationStructure.vue";
import UsersRoles from "@/views/complyon_views/UsersRoles/ComplyonUsersRoles.vue";
import MasterData from "@/views/complyon_views/MasterData/ComplyonMasterData.vue";
import Integrations from "@/views/complyon_views/Integrations/ComplyonIntegrations.vue";
import SystemSettings from "@/views/complyon_views/SystemSettings/ComplyonSystemSettings.vue";
import Workflows from "@/views/complyon_views/Workflows/ComplyonWorkflows.vue";
import OnboardingHandoff from "@/views/complyon_views/OnboardingHandoff/ComplyonOnboardingHandoff.vue";

const complyon_routes = [
  {
    path: "/command-centre",
    name: "ComplyonCommandCentre",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "CommandCentre",
        component: CommandCenter,
        meta: {
          navSection: 'OVERVIEW',
          navTitle: 'Command centre'
        }
      }
    ]
  },
  {
    path: "/my-tasks",
    name: "ComplyonTasks",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "MyTasks",
        component: MyTasks,
        meta: {
          navSection: 'OVERVIEW',
          navTitle: 'My tasks'
        }
      }
    ]
  },
  {
    path: "/controls-library",
    name: "ComplyonControlsLibrary",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "ControlsLibrary",
        component: ControlsLibrary,
        meta: {
          navSection: 'COMPLIANCE DOMAINS',
          navTitle: 'Controls library'
        }
      }
    ]
  },
  {
    path: "/governance",
    name: "ComplyonGovernance",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "Governance",
        component: Governance,
        meta: {
          navSection: 'COMPLIANCE DOMAINS',
          navTitle: 'Company governance'
        }
      }
    ]
  },
  {
    path: "/obligations-register",
    name: "ComplyonObligationsRegister",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "ObligationsRegister",
        component: ObligationsRegister,
        meta: {
          navSection: 'GOVERNANCE & CONTROLS',
          navTitle: 'Obligations register'
        }
      }
    ]
  },
  {
    path: "/exceptions-deviations",
    name: "ComplyonExceptionsDeviations",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "ExceptionsDeviations",
        component: ExceptionsDeviations,
        meta: {
          navSection: 'GOVERNANCE & CONTROLS',
          navTitle: 'Exceptions & deviations'
        }
      }
    ]
  },
  {
    path: "/corrective-actions",
    name: "ComplyonCorrectiveActions",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "FindingsCorrectiveActions",
        component: FindingsCorrectiveActions,
        meta: {
          navSection: 'ASSURANCE',
          navTitle: 'Findings & corrective actions'
        }
      }
    ]
  },
  {
    path: "/compliance-policies",
    name: "ComplyonPolicies",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "CompliancePolicies",
        component: CompliancePolicies,
        meta: {
          navSection: 'COMPLIANCE DOMAINS',
          navTitle: 'Compliance policies'
        }
      }
    ]
  },
  {
    path: "/compliance-procurement",
    name: "ComplyonProcurement",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "ComplianceProcurement",
        component: ComplianceProcurement,
        meta: {
          navSection: 'COMPLIANCE DOMAINS',
          navTitle: 'Compliance procurement'
        }
      }
    ]
  },
  {
    path: "/finance-compliance",
    name: "ComplyonFinance",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "FinanceCompliance",
        component: FinanceCompliance,
        meta: {
          navSection: 'COMPLIANCE DOMAINS',
          navTitle: 'Finance compliance'
        }
      }
    ]
  },
  {
    path: "/contract-lifecycle",
    name: "ComplyonContracts",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "ContractLifecycle",
        component: ContractLifecycle,
        meta: {
          navSection: 'COMPLIANCE DOMAINS',
          navTitle: 'Contract lifecycle'
        }
      }
    ]
  },
  {
    path: "/employee-register",
    name: "ComplyonEmployees",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "EmployeeRegister",
        component: EmployeeRegister,
        meta: {
          navSection: 'COMPLIANCE DOMAINS',
          navTitle: 'Employee register'
        }
      }
    ]
  },
  {
    path: "/data-privacy",
    name: "ComplyonDataPrivacy",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "DataPrivacy",
        component: DataPrivacy,
        meta: {
          navSection: 'COMPLIANCE DOMAINS',
          navTitle: 'Data privacy'
        }
      }
    ]
  },
  {
    path: "/records-retention",
    name: "ComplyonRecordsRetention",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "RecordsRetention",
        component: RecordsRetention,
        meta: {
          navSection: 'DATA, SECURITY & RECORDS',
          navTitle: 'Records & retention'
        }
      }
    ]
  },
  {
    path: "/business-continuity",
    name: "ComplyonBusinessContinuity",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "BusinessContinuity",
        component: BusinessContinuity,
        meta: {
          navSection: 'DATA, SECURITY & RECORDS',
          navTitle: 'Business continuity'
        }
      }
    ]
  },
  {
    path: "/supplier-register",
    name: "ComplyonSupplierRegister",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "SupplierRegister",
        component: SupplierRegister,
        meta: {
          navSection: 'COMPLIANCE DOMAINS',
          navTitle: 'Supplier register'
        }
      }
    ]
  },
  {
    path: "/asset-register",
    name: "ComplyonAssetRegister",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "AssetRegister",
        component: AssetRegister,
        meta: {
          navSection: 'COMPLIANCE DOMAINS',
          navTitle: 'Asset register'
        }
      }
    ]
  },
  {
    path: "/facilities-sites",
    name: "ComplyonFacilitiesSites",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "FacilitiesSites",
        component: FacilitiesSites,
        meta: {
          navSection: 'COMPLIANCE DOMAINS',
          navTitle: 'Facilities & sites'
        }
      }
    ]
  },
  {
    path: "/health-safety-environment",
    name: "ComplyonHealthSafetyEnvironment",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "HealthSafetyEnvironment",
        component: HealthSafetyEnvironment,
        meta: {
          navSection: 'OPERATIONAL COMPLIANCE',
          navTitle: 'Health, safety & environment'
        }
      }
    ]
  },
  {
    path: "/licences-permits-certifications",
    name: "ComplyonLicencesPermitsCertifications",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "LicencesPermitsCertifications",
        component: LicencesPermitsCertifications,
        meta: {
          navSection: 'OPERATIONAL COMPLIANCE',
          navTitle: 'Licences, permits & certifications'
        }
      }
    ]
  },
  {
    path: "/insurance-claims",
    name: "ComplyonInsuranceClaims",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "InsuranceClaims",
        component: InsuranceClaims,
        meta: {
          navSection: 'OPERATIONAL COMPLIANCE',
          navTitle: 'Insurance & claims'
        }
      }
    ]
  },
  {
    path: "/service-delivery-performance",
    name: "ComplyonServiceDeliveryPerformance",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "ServiceDeliveryPerformance",
        component: ServiceDeliveryPerformance,
        meta: {
          navSection: 'OPERATIONAL COMPLIANCE',
          navTitle: 'Service delivery & performance'
        }
      }
    ]
  },
  {
    path: "/grant-funding-compliance",
    name: "ComplyonGrantFundingCompliance",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "GrantFundingCompliance",
        component: GrantFundingCompliance,
        meta: {
          navSection: 'OPERATIONAL COMPLIANCE',
          navTitle: 'Grant & funding compliance'
        }
      }
    ]
  },
  {
    path: "/training-program",
    name: "ComplyonTraining",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "TrainingProgram",
        component: TrainingProgram,
        meta: {
          navSection: 'COMPLIANCE DOMAINS',
          navTitle: 'Training program'
        }
      }
    ]
  },
  {
    path: "/it-security",
    name: "ComplyonItSecurity",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "ItSecurity",
        component: ItSecurity,
        meta: {
          navSection: 'COMPLIANCE DOMAINS',
          navTitle: 'IT security'
        }
      }
    ]
  },
  {
    path: "/risks",
    name: "ComplyonRisks",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "RisksDashboard",
        component: RisksDashboard,
        meta: {
          navSection: 'ASSURANCE',
          navTitle: 'Risks'
        }
      }
    ]
  },
  {
    path: "/incidents-cases",
    name: "ComplyonIncidentsCases",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "IncidentsCases",
        component: IncidentsCases,
        meta: {
          navSection: 'ASSURANCE',
          navTitle: 'Incidents & cases'
        }
      }
    ]
  },
  {
    path: "/conflicts-of-interest",
    name: "ComplyonConflictsOfInterest",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "ConflictsOfInterest",
        component: ConflictsOfInterest,
        meta: {
          navSection: 'ASSURANCE',
          navTitle: 'Conflicts of interest'
        }
      }
    ]
  },
  {
    path: "/legal-matters",
    name: "ComplyonLegalMattersLitigation",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "LegalMattersLitigation",
        component: LegalMattersLitigation,
        meta: {
          navSection: 'ASSURANCE',
          navTitle: 'Legal matters & litigation'
        }
      }
    ]
  },
  {
    path: "/complaints-grievances",
    name: "ComplyonComplaintsGrievances",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "ComplaintsGrievances",
        component: ComplaintsGrievances,
        meta: {
          navSection: 'ASSURANCE',
          navTitle: 'Complaints & grievances'
        }
      }
    ]
  },
  {
    path: "/ethics-whistleblowing",
    name: "ComplyonEthicsWhistleblowing",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "EthicsWhistleblowing",
        component: EthicsWhistleblowing,
        meta: {
          navSection: 'ASSURANCE',
          navTitle: 'Ethics & whistleblowing'
        }
      }
    ]
  },
  {
    path: "/audits",
    name: "ComplyonAudits",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "AuditsRegister",
        component: AuditsRegister,
        meta: {
          navSection: 'ASSURANCE',
          navTitle: 'Audits'
        }
      }
    ]
  },
  {
    path: "/regulatory-calendar",
    name: "ComplyonRegulatoryCalendar",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "RegulatoryCalendar",
        component: RegulatoryCalendar,
        meta: {
          navSection: 'ASSURANCE',
          navTitle: 'Regulatory calendar'
        }
      }
    ]
  },
  {
    path: "/evidence-vault",
    name: "ComplyonEvidenceVault",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "EvidenceVault",
        component: EvidenceVault,
        meta: {
          navSection: 'ASSURANCE',
          navTitle: 'Evidence vault'
        }
      }
    ]
  },
  {
    path: "/reports",
    name: "ComplyonReports",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "ReportsDashboard",
        component: ReportsDashboard,
        meta: {
          navSection: 'ASSURANCE',
          navTitle: 'Reports'
        }
      }
    ]
  },
  {
    path: "/delegation-of-authority",
    name: "ComplyonDelegationOfAuthority",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "DelegationOfAuthority",
        component: DelegationOfAuthority,
        meta: {
          navSection: 'OVERVIEW',
          navTitle: 'Delegation of authority'
        }
      }
    ]
  },
  {
    path: "/board-audit-packs",
    name: "ComplyonBoardAuditPacks",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "BoardAuditPacks",
        component: BoardAuditPacks,
        meta: {
          navSection: 'ASSURANCE',
          navTitle: 'Board & audit packs'
        }
      }
    ]
  },
  {
    path: "/organisation-structure",
    name: "ComplyonOrganisationStructure",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "OrganisationStructure",
        component: OrganisationStructure,
        meta: {
          navSection: 'ADMINISTRATION',
          navTitle: 'Organisation structure'
        }
      }
    ]
  },
  {
    path: "/users-roles",
    name: "ComplyonUsersRoles",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "UsersRoles",
        component: UsersRoles,
        meta: {
          navSection: 'ADMINISTRATION',
          navTitle: 'Users & roles'
        }
      }
    ]
  },
  {
    path: "/master-data",
    name: "ComplyonMasterData",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "MasterData",
        component: MasterData,
        meta: {
          navSection: 'ADMINISTRATION',
          navTitle: 'Master data'
        }
      }
    ]
  },
  {
    path: "/integrations",
    name: "ComplyonIntegrations",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "Integrations",
        component: Integrations,
        meta: {
          navSection: 'ADMINISTRATION',
          navTitle: 'Integrations'
        }
      }
    ]
  },
  {
    path: "/system-settings",
    name: "ComplyonSystemSettings",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "SystemSettings",
        component: SystemSettings,
        meta: {
          navSection: 'ADMINISTRATION',
          navTitle: 'System settings'
        }
      }
    ]
  },
  {
    path: "/onboarding-handoff",
    name: "ComplyonOnboardingHandoff",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "OnboardingHandoff",
        component: OnboardingHandoff,
        meta: {
          navSection: 'OVERVIEW',
          navTitle: 'Onboarding handoff',
          searchPlaceholder: 'Search suppliers, contracts, controls, evidence...'
        }
      }
    ]
  },
  {
    path: "/workflows",
    name: "ComplyonWorkflows",
    component: Configslayout,
    children: [
      {
        path: "",
        name: "Workflows",
        component: Workflows,
        meta: {
          navSection: 'OVERVIEW',
          navTitle: 'Workflows'
        }
      }
    ]
  }
];

export default complyon_routes;
